import markUrl from "../assets/logo-mark-qr.png";

/**
 * Error correction for branded QR codes: "H" still reads with up to ~30% of the code covered,
 * well above the logo's share, so phones scan it as reliably as a plain code.
 */
export const QR_LEVEL = "H" as const;

/** The logo's width as a share of the code: small, so the code stays easy to scan. */
const LOGO_SHARE = 0.18;

/**
 * The black UnizPay mark in the centre of a QR code, for qrcode.react's `imageSettings`. The
 * dots under it are removed (excavate), and the image's clear padding keeps them off the mark.
 * Use with `level={QR_LEVEL}` and dark dots on white.
 */
export function qrLogo(size: number) {
  const side = Math.round(size * LOGO_SHARE);
  return { src: markUrl, width: side, height: side, excavate: true };
}
